// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lazyLoad{display:block;opacity:0}.isLoaded,.lazyLoad{transition:opacity .2s ease-in}.isLoaded{opacity:1}.lazy-image__img{width:100%;height:100%}.lazy-image__placeholder{position:absolute;top:0;bottom:0;z-index:100;display:flex;justify-content:center;align-items:center;width:100%;height:100%;background-color:#dadada}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
